import React from 'react';

export default function useSticky(ref) {
  const [hasScrolled, setHasScrolled] = React.useState(false);
  const element = ref.current;
  const sticky = element ? Math.max(element.getBoundingClientRect().top, 0) : undefined;
  const setScrolled = () => setHasScrolled(true);
  const resetScrolled = () => setHasScrolled(false);

  React.useEffect(() => {
    document.addEventListener('scroll', setScrolled);
    return () => document.removeEventListener('scroll', setScrolled);
  }, []);

  React.useEffect(() => {
    window.onscroll = function() {
      if (!element || sticky === undefined) return;
      if (window.pageYOffset > sticky) {
        element.style.position = 'fixed';
      } else {
        if (window.pageYOffset === 0) {
          resetScrolled();
        }
        element.style.position = 'relative';
        element.style.top = undefined;
      }
    };
    return () => {
      window.onscroll = undefined;
    };
  }, [hasScrolled]);
}
